import { memo, useCallback, useMemo } from "react";

import classes from "./MrqNotesCell.module.css";
import classesCell from "./BodyCell.module.css";
import { truncateString } from "../../../lib/script";
import { useWorkQShell, WorkQHoverHint } from "../context/workQShellContext";
import WorkQDeferredTooltip from "./WorkQDeferredTooltip";

function MrqNotesCell({ note, caseData, data, group, label, workq }) {
    const shell = useWorkQShell();
    const rowData = caseData ?? data;
    const noteText = note ?? (group && label ? rowData?.[group]?.[label] : null) ?? null;

    const displayText = useMemo(() => {
        if (!noteText) {
            return null;
        }
        return noteText.length > 20 ? truncateString(noteText, 20) : noteText;
    }, [noteText]);

    const openEditModal = useCallback(() => {
        if (!shell) {
            return;
        }
        shell.openModal({
            kind: "modal_mrq_notes",
            caseData: rowData,
            workq,
            initialNote: noteText ?? "",
        });
    }, [shell, rowData, workq, noteText]);

    const cellInner = (
        <button
            type="button"
            className={`${classes.mrq_notes_cell} ${classesCell.body_cell}`}
            style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" }}
            onClick={openEditModal}
            title="Edit MRQ notes"
        >
            {displayText ? (
                <span className={classes.note_text} style={{ textAlign: "center", width: "100%" }}>{displayText}</span>
            ) : (
                <span className={classes.placeholder} style={{ textAlign: "center", width: "100%" }}>—</span>
            )}
        </button>
   
    );

    if (!noteText) {
        return cellInner;
    }

    if (shell) {
        return (
            <WorkQHoverHint message={noteText} disabled={!noteText} className={classes.tooltip_wrapper}>
                {cellInner}
            </WorkQHoverHint>
        );
    }

    return (
        <WorkQDeferredTooltip normalEvent={true} messages={[noteText]} wrapperClassName={classes.tooltip_wrapper}>
            {cellInner}
        </WorkQDeferredTooltip>
    );
}

function mrqNotesCellPropsEqual(prevProps, nextProps) {
    const prevNote =
        prevProps.note ??
        (prevProps.group && prevProps.label
            ? prevProps.caseData?.[prevProps.group]?.[prevProps.label] ?? prevProps.data?.[prevProps.group]?.[prevProps.label]
            : null);
    const nextNote =
        nextProps.note ??
        (nextProps.group && nextProps.label
            ? nextProps.caseData?.[nextProps.group]?.[nextProps.label] ?? nextProps.data?.[nextProps.group]?.[nextProps.label]
            : null);

    return prevNote === nextNote;
}

export default memo(MrqNotesCell, mrqNotesCellPropsEqual);
